import { render } from "./PeripheralIcon.vue?vue&type=template&id=ac2cabec&ts=true"
import script from "./PeripheralIcon.vue?vue&type=script&lang=ts"
export * from "./PeripheralIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__